import React from 'react';
import PropTypes from 'prop-types';

import './style.css';

export const BankAccount = ({userinfo: { sources }, link}) => {
  if(sources && sources.length) {
    return (
      <section>
        {sources.map(({name, id}) => (
          <div styleName="bank" key={id}>
            <p data-test="profile_account_name">{name}&nbsp;</p><p><a onClick={() => link()} data-test="profile_link_change">Change</a></p>
          </div>
        ))}
      </section>
    )
  }
  return (
    <div styleName="bank">
      <p data-test="profile_none">None on file&nbsp;</p><p><a onClick={() => link()} data-test="profile_link">Link Bank Account</a></p>
    </div>
  );
};

BankAccount.propTypes = {
  // TODO:
  userinfo: PropTypes.shape({
    sources: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired
      }
    )).isRequired
  }).isRequired,
  link: PropTypes.func.isRequired,
};

export default BankAccount;



// WEBPACK FOOTER //
// ./web/flows/account/components/BankAccount/component.js